<article tabindex="0">
  <div *ngIf="showEditMenu" class="edit-actions-container">
    <opac-button [ariaLabel]="'common.edit' | translate" [opacTooltip]="'common.edit' | translate" (click)="handleUpdateButtonClick()">
      <opac-icon icon="edit" slot="only-icon"></opac-icon>
    </opac-button>

    <opac-button [ariaLabel]="'common.delete' | translate" [opacTooltip]="'common.delete' | translate" (click)="handleDeleteButtonClick()">
      <opac-icon icon="delete" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <div class="header" *ngIf="challenge">
    <div class="title">
      <h3>{{ challenge.name }}</h3>

      <opac-button *ngIf="showEditMenu" [matMenuTriggerFor]="editMenu">
        <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
      </opac-button>

      <mat-menu #editMenu>
        <button class="edit-menu-button" mat-menu-item (click)="handleUpdateButtonClick()">
          <span class="odilo-icon">edit</span>
          <span>{{ 'common.edit' | translate }}</span>
        </button>
        <button class="edit-menu-button" mat-menu-item (click)="handleDeleteButtonClick()">
          <span class="odilo-icon">delete</span>
          <span>{{ 'common.delete' | translate }}</span>
        </button>
      </mat-menu>
    </div>

    <div class="progress">
      <opac-progress-spinner [progress]="count$ | async" progressText="%">
        <opac-icon [class.completed]="challenge.progress >= challenge.target" [icon]="icon" [size]="iconSize"></opac-icon>
      </opac-progress-spinner>

      <span *ngIf="challenge.progress >= challenge.target">{{ 'challenges.completed' | translate }}</span>
    </div>

    <div class="info">
      <div>
        <span>{{ progressLabel | translate }}</span>
        <span>{{ challenge.progress }}/{{ challenge.target }}</span>
      </div>

      <div *ngIf="challenge.expirationDate">
        <span>{{ 'challenges.daysLeftTitle' | translate }}</span>
        <span>{{ getDaysLeft() }}</span>
      </div>
    </div>
  </div>
  <div class="contents">
    <ng-container *ngIf="challenge">
      <h3>{{ challenge.name }}</h3>

      <p [innerHTML]="getChallengeDescriptionLabel()"></p>

      <ng-content></ng-content>

      <div class="createdBy">
        <span>{{ createdByLabel | translate }} - {{ challenge.creationDate | date:'mediumDate' }}</span>
        <span *ngIf="challenge.expirationDate">
          <opac-icon icon="clock"></opac-icon>
          <span class="days-left">{{ getDaysLeft() }}</span>
          <span class="days-left-text">&nbsp;{{ 'challenges.daysLeftTitle' | translate }}</span>
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="!challenge">
      <ng-content select="[slot='empty-challenge']"></ng-content>
    </ng-container>
  </div>
  <div class="controls" *ngIf="challenge">
    <ng-content select="[slot='controls']"></ng-content>
  </div>
</article>
